const checkVersion = (onVersionMismatch: Function) => {
  return getAppVersion()
    .then((appVersion) => {
      const frontendVersion = process.env.REACT_APP_VERSION;
      if (appVersion !== frontendVersion) onVersionMismatch();
    })
    .then(() => setTimeout(() => checkVersion(onVersionMismatch), 300000));
};

const getAppVersion = () => {
  return fetch(`${process.env.REACT_APP_API || ''}/version`)
    .then(response => response.json())
    .then(json => json.version)
    .catch(err => process.env.REACT_APP_VERSION);
};

export { checkVersion };
